import nav from './modules/nav';
import contagion from './modules/contagion';
import statCounters from './modules/stat-counters';
import competition from './modules/competition';
import rail from './modules/rail';
import carousel from './modules/carousel';
import picks from './modules/picks';
import parallax from './modules/parallax';
import popOut from './modules/pop-out';
import video from './modules/video';
import curriculumTable from './modules/curriculum-table';
import homeFx from './modules/home-fx';

function boot() {
    nav();
    contagion();
    statCounters();
    competition();
    rail();
    carousel();
    picks();
    parallax();
    popOut();
    video();
    curriculumTable();
    homeFx();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}
